import { Button } from '@finn-auto/design-system/atoms/button';
import type { OutreachCandidate } from '../../types/taOutreach';

/**
 * Accepted people whose profile is not read yet (Sofia, Oct 28 2026): only the extension can read
 * it, so it needs a click; everyone with a read profile is drafted by itself. Hidden when empty.
 */
export function UnreadProfilesBox({ people, disabled, onRead }: { people: OutreachCandidate[]; disabled: boolean; onRead: () => void }) {
  if (!people.length) return null;
  return (
    <div className="flex flex-wrap items-center gap-2.5 rounded-md border border-solid border-[#F5C26B] bg-[#FFF8E6] px-[18px] py-[13px] text-[13px] text-[#7A4B00]">
      <span>
        <b>{people.length}</b> accepted, profile not read yet: {people.map((c) => c.name).join(', ')}.
      </span>
      <span className="flex-1" />
      <Button size="sm" variant="outline" disabled={disabled} onClick={onRead}>
        Read profiles
      </Button>
    </div>
  );
}
